import Cookies from 'js-cookie';
import useAuthStore from 'store/useAuthStore';
import { cookiesRefreshTokenName, cookiesTokenName } from 'utils/helper';
import axiosConfig from './axiosConfig';

export const loginData = {
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
    scopes: "Admin,Manager,Technician"
}

/**
 * Login user with credentials
 * @param {Object} credentials - User login credentials
 * @param {string} credentials.username - User username
 * @param {string} credentials.password - User password 
 * @returns {Promise} Response from login API
 */
export const login = async (credentials) => {
    try {
        let data = { ...loginData,...credentials}
        data.grant_type = 'password'
        data.user_agent_string = navigator.userAgent

        const response = await axiosConfig.post('/auth/login', data);
        if (response.data?.access_token) {
            Cookies.set(cookiesTokenName, response.data.access_token, { expires: 30, secure: true, sameSite: 'None', path: '/' });
            Cookies.set(cookiesRefreshTokenName, response.data.refresh_token, { expires: 365, secure: true, sameSite: 'None', path: '/' });
            let user = response.data.user
            useAuthStore.setState({ token: response.data.access_token, profile: user })
            delete user.id
            localStorage.setItem("user", JSON.stringify(user))
        }
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Remove device token by token string
 * @param {string} token - Device token to remove
 * @returns {Promise} Response from API
 */
export const clearFcmKey = async (token) => {
    try {
        const response = await axiosConfig.post(`auth/fcmkey/clear/${token}`);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Refresh authentication token
 * @returns {Promise} Response from API
 */
export const refreshToken = async () => {
    try {
        const response = await axiosConfig.post('auth/refresh');
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Change password for authenticated user
 * @param {Object} data - Password change data
 * @param {string} data.old_password - Current password
 * @param {string} data.new_password - New password
 * @returns {Promise} Response from API
 */
export const changePassword = async (data) => {
    try {
        const response = await axiosConfig.post('changepassword', data);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Store (associate) device token
 * @param {Object} data - Device token data
 * @param {string} data.token - Device token to store
 * @returns {Promise} Response from API
 */
export const storeDeviceToken = async (data) => {
    try {
        const response = await axiosConfig.post('devicetoken', data);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Remove device token by ID
 * @param {string|number} id - Device token ID to remove
 * @returns {Promise} Response from API
 */
export const removeDeviceToken = async (id) => {
    try {
        const response = await axiosConfig.delete(`devicetoken/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};